<template>
  <sidenav :orientation="orientation" :class="curClasses">
    <!-- Inner -->
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
      <core-Menu v-for="routeMenu in routes.filter(p => p.menu)" :item="routeMenu"></core-Menu>
    </div>
  </sidenav>
</template>

<script>
  import {
    Sidenav,
    SidenavLink,
    SidenavRouterLink,
    SidenavMenu,
    SidenavHeader,
    SidenavBlock,
    SidenavDivider
  } from '@/vendor/libs/sidenav'

  export default {
    name: 'app-layout-sidenav',
    components: {
      /* eslint-disable vue/no-unused-components */
      Sidenav,
      SidenavLink,
      SidenavRouterLink,
      SidenavMenu,
      SidenavHeader,
      SidenavBlock,
      SidenavDivider
      /* eslint-enable vue/no-unused-components */
    },
    props: {
      orientation: {
        type: String,
        default: 'vertical'
      }
    },

    computed: {
      curClasses() {
        let bg = this.layoutSidenavBg

        if (
          this.orientation === 'horizontal' &&
          (bg.indexOf(' sidenav-dark') !== -1 ||
            bg.indexOf(' sidenav-light') !== -1)
        ) {
          bg = bg
            .replace(' sidenav-dark', '')
            .replace(' sidenav-light', '')
            .replace('-darker', '')
            .replace('-dark', '')
        }

        return (
          `bg-${bg} ` +
          (this.orientation !== 'horizontal'
            ? 'layout-sidenav'
            : 'layout-sidenav-horizontal container-p-x flex-grow-0')
        )
      },
      routes() {
        return this.$router.options.routes.filter(i => i.menu)
      },
      userRoles() {
        return JSON.parse(localStorage.getItem('user')).roles
      }
    },

    methods: {
      isMenuActive(url) {
        return this.$route.path.indexOf(url) === 0
      },
      isMenuOpen(url) {
        return (
          this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
        )
      },
      toggleSidenav() {
        this.layoutHelpers.toggleCollapsed()
      }
    }
  }
</script>
